














































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { default as format } from 'date-fns/format';
import $ from 'jquery';
import VDateTimeDuring from './VDateTimeDuring.vue';
import reportModule from '@/store/modules/common/report.module';
import departmentService from '@/services/common/department.service';
import authModule from '@/store/modules/common/auth.module';
import Mixin from '@/mixin';
import reportViewModel from '@/views/mastercoach/reportViewModel';

@Component({
  name: 'VHeaderItem',
  components: { VDateTimeDuring }
})
export default class VHeaderItem extends Mixin {
  @Prop({ required: true }) score?: number;
  public isEdit = false;
  public company: string = '';
  public department: string = '';
  public departments: string[] = [];
  public reportType: string = ''

  @Watch('department', { deep: true, immediate: true })
  public updateDepartment() {
    this.handleReport();
  }

  get isDepartmentReport() {
    return this.reportType === 'department';
  }

  get title() {
    if (this.isDepartmentReport) {
      return this.department;
    }
    return this.company;
  }

  public handleToggle() {
    this.isEdit = !this.isEdit;
  }

  public handleReport() {
    this.isEdit = false;
    const companyName = this.company ?? reportViewModel.company
    
    if (!companyName) { return }
    reportModule
      .loadReport({
        companyName,
        fromDate: window.sessionStorage.getItem('REPORT_FROM_DATE') || reportViewModel.startDate,
        toDate: window.sessionStorage.getItem('REPORT_TO_DATE') || reportViewModel.endDate,
        department: this.department || reportViewModel.department,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone
      })
  }

  public formatDate() {
    const fromDate = window.sessionStorage.getItem('REPORT_FROM_DATE') || reportViewModel.startDate;
    const toDate = window.sessionStorage.getItem('REPORT_TO_DATE') || reportViewModel.endDate;
    const from = new Date(fromDate as string);
    const to = new Date(toDate as string);
    return `${format(from, 'yyyy-MM-dd')} to ${format(to, 'yyyy-MM-dd')}`;
  }

  public async loadCompanies() {
    this.company = reportViewModel.company ?? authModule.user?.companyName;
    this.departments = await departmentService.loadDepartments(this.company)
  }

  mounted() {
    reportViewModel.loadReportParams();
    this.department = reportViewModel.department
    this.company = reportViewModel.company
    this.reportType = reportViewModel.reportType
    this.loadCompanies();
  }

  public async print(e) {
    $('.v-top-nav').hide(0);
    $('.c-menu').hide(0);
    $('.c_container').css('margin-left','unset');
    $('.c_container').css('margin-right','unset');
    $('.c_table__body').css('overflow-y','hidden');
    $('.c_table__body').css('max-height','none');
    $('#chart_content').css('overflow-y','hidden');
    $('#chart_content').css('max-height','none');
    $('.no-print').css('display','none');
    $('.table-wrapper').css('height','unset');
    $('.table-wrapper').css('overflow-y','hidden');
    $('.c-overall-report').css('padding','0rem');
    await window.print();
    $('.v-top-nav').show(0);
    $('.c-menu').show(0);
    $('.c_container').css('margin-left','11rem');
    $('.c_container').css('margin-right','11rem');
    $('.c_table__body').css('max-height','70vh');
    $('.c_table__body').css('overflow-y','auto')
    $('#chart_content').css('overflow-y','auto');
    $('#chart_content').css('max-height','70vh');
    $('.no-print').css('display','block');
    $('.table-wrapper').css('height','60vh');
    $('.table-wrapper').css('overflow-y','auto');
    $('.c-overall-report').css('padding','0rem 4rem 4rem 4rem');
  }
}
